import { render, staticRenderFns } from "./dashboardIndex.vue?vue&type=template&id=5202647c&"
import script from "./dashboardIndex.vue?vue&type=script&lang=js&"
export * from "./dashboardIndex.vue?vue&type=script&lang=js&"
import style0 from "./dashboardIndex.vue?vue&type=style&index=0&id=5202647c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports